module.exports = __webpack_public_path__ + "static/media/canari_logo_birthday.c720041d.png";